import React, { useEffect, useState } from 'react';
import { WifiOff, Cloud, Loader2 } from 'lucide-react';
import { useOnlineStatus } from '../../hooks/useOnlineStatus';
import { getSubmissionQueue } from '../../services/offlineStorage';

export const OfflineIndicator: React.FC = () => {
  const { isOnline } = useOnlineStatus();
  const [queueLength, setQueueLength] = useState(0);
  const [isSyncing, setIsSyncing] = useState(false);

  useEffect(() => {
    // Check queue length periodically
    const checkQueue = async () => {
      const queue = await getSubmissionQueue();
      setQueueLength(queue.length);
    };

    checkQueue();
    const interval = setInterval(checkQueue, 2000); // Check every 2 seconds

    return () => clearInterval(interval);
  }, []);

  // Listen for sync events
  useEffect(() => {
    const handleSyncStart = () => setIsSyncing(true);
    const handleSyncComplete = () => {
      setIsSyncing(false);
      // Refresh queue count
      getSubmissionQueue().then(queue => setQueueLength(queue.length));
    };

    window.addEventListener('sync-start', handleSyncStart);
    window.addEventListener('sync-complete', handleSyncComplete);

    return () => {
      window.removeEventListener('sync-start', handleSyncStart);
      window.removeEventListener('sync-complete', handleSyncComplete);
    };
  }, []);

  // Don't show anything if online and no pending items
  if (isOnline && queueLength === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      {!isOnline && (
        <div className="flex items-center gap-1.5 px-2 py-1 bg-yellow-100 text-yellow-800 rounded-md text-xs font-medium">
          <WifiOff className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Offline</span>
        </div>
      )}
      
      {queueLength > 0 && (
        <div className="flex items-center gap-1.5 px-2 py-1 bg-blue-100 text-blue-800 rounded-md text-xs font-medium">
          {isSyncing ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
          ) : (
            <Cloud className="h-3.5 w-3.5" />
          )}
          <span>{queueLength} pending</span>
        </div>
      )}
    </div>
  );
};
